<div class="culture-score-details_container">
  @if (isLoading) {
  <div class="culture-score-details_score-tooltip_container loading">
    <span class="culture-score-details_scoreText loading"></span>
    <span class="culture-score-details_loadingStateIcon"></span>
  </div>
  <div class="culture-score-details_progressBar_container loading">
    <div class="culture-score-details_loadingStateProgressBar"></div>
  </div>
  } @else {
  <!-- <div class="temp" style="display: flex; flex-direction: column; width: 100%"> -->
  <!-- style="gap: 0; justify-content: space-between; padding-bottom: 12px" -->
  <div class="culture-score-details_progressBar_container">
    <app-claro-progress-bar
      [value]="cultureScore"
      [height]="'5px'"
      [fillColor]="progressBarColorString"
    ></app-claro-progress-bar>
  </div>
  <div class="culture-score-details_score-tooltip_container">
    <span class="culture-score-details_scoreText">{{ cultureScore }}%</span>
    <app-claro-tooltip-icon
      [translatedTooltipText]="'stateView.tooltipTexts.cultureScore' | translate"
    ></app-claro-tooltip-icon>
  </div>

  <!-- </div> -->

  }
</div>
